import React, { useEffect, useState } from 'react'
import { Box, Button, DialogActions, Dialog, DialogContent, Divider, FormControl, Grid, InputLabel, MenuItem, Pagination, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Tooltip, Typography, ListItem, ListItemText, List, TablePagination } from '@mui/material';
import { fetchPlatforms } from '../../store/platformSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLeadById, fetchLeadData } from '../../store/LeadSlice';
import PropTypes from 'prop-types';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import { alpha } from '@mui/material/styles';
import { ROWS_PER_PAGE } from '../../utils/constant';
import Loader from '../Common/Loader';
import { NoData } from '../Common/NoData';
import { useLocation, useNavigate } from 'react-router-dom';
import ReadMoreArea from '@foxeian/react-read-more';

function createData(
  name,
  email,
  phone,
  source,
  commentText,
  videoId,
  commentType,
  createAt,
) {
  return {
    name,
    email,
    phone,
    source,
    commentText,
    videoId,
    commentType,
    createAt,
  };
}

const headCells = [
  {
    label: 'Name',
    numeric: false,
    disablePadding: false,
    id: 'name',
  },
  {
    label: 'Email',
    numeric: false,
    disablePadding: false,
    id: 'email',
  },
  {
    label: 'Phone',
    numeric: false,
    disablePadding: false,
    id: 'role',
  },
  {
    label: 'Source',
    numeric: false,
    disablePadding: false,
    id: 'Source',
  },

  {
    label: 'Comment Text',
    numeric: false,
    disablePadding: false,
    id: 'commentText',
  },
  {
    label: 'Video Id',
    numeric: false,
    disablePadding: false,
    id: 'videoId',
  },
  {
    label: 'Comment Type',
    numeric: false,
    disablePadding: false,
    id: 'commentType',
  },
  {
    label: 'Timestamp',
    numeric: false,
    disablePadding: false,
    id: 'active',
  },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            className='font-weight'
            key={headCell.id}
            align={headCell.numeric ? 'left' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              color='secondary'
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
const handleExport = async (previewPayload) => {
  const token = localStorage.getItem('userAuthToken');
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/leads/export_leads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(previewPayload)
    });
    if (response.ok) {
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'exported_leads.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
  }
}
function EnhancedTableToolbar(props) {
  const previewPayload = useSelector((state) => state.leadReducer.previewPayload)

  const { numSelected } = props;
  const navigate = useNavigate()
  return (
    <>
      <Toolbar
        className='table-container'
        sx={[
          {
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
          },
          numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
          },
        ]}
      >
        <Typography
          className="d-flex flex-grow-1 flex-shrink-1 flex-fill"
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Leads
        </Typography>
        <Tooltip title="Create">
          <Button variant="contained" mr={2} className='mr-2' onClick={() => { navigate("/leads") }}>Back</Button>
          <Button variant="contained" ml={2} onClick={() => { handleExport(previewPayload) }}>Export</Button>
        </Tooltip>


      </Toolbar>
    </>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const ManageLeadPreview = () => {

  const leadData = useSelector((state) => state.leadReducer.leadData)
  const loading = useSelector((state) => state.leadReducer.loading)
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const location = useLocation();
  const formData = location.state || {};

  const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchLeadData({
      platform_id: formData.platform,
      industry_id: formData.industry_id,
      page: 1,
      page_size: formData.num_leads
    }))
  }, [])
  React.useEffect(() => {
    // name, source, platform, videoId, commentId, commentText, author, commentType, channelId, email, phone, timestamp
    const rowData = leadData?.results?.map((ele) => createData(
      ele.name,
      ele.email,
      ele.phone,
      ele.source,
      ele?.platform_leads?.data?.comment_text,
      ele?.platform_leads?.data?.video_id,
      ele?.platform_leads?.data?.comment_type,
      formatDate( ele?.platform_leads?.data?.created_at),
      formatDate(ele.created_at)))
    setRows(rowData)
  }, [leadData])

  const visibleRows = React.useMemo(() => {

    if (rows?.length) {

      return [...rows]
        .sort(getComparator(order, orderBy))
      // .slice(0 * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }
  }, [rows, order, orderBy, page, rowsPerPage]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const data = {
      client_id: formData.platform_id,
      industry_id: formData.industry_id,
      page: newPage,
      page_size: rowsPerPage
    }
    dispatch(fetchLeadData(data))
  };


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
    const data = {
      client_id: formData.platform_id,
      industry_id: formData.industry_id,
      platform_id: formData.platform_id,
      page: page,
      page_size: parseInt(event.target.value, 10)
    }
    dispatch(fetchLeadData(data))
  };


  return (
    <>
      <Paper sx={{ overflow: 'hidden', width: '100%' }} className="w-100 mb-2" >
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer sx={{ overflowX: 'auto', width: '100%', display: 'block' }} className='position-relative'>
          <Table
            className='min-width-750'
            aria-labelledby="tableTitle"
            size={'small'}
            stickyHeader
            aria-label="sticky table"
            sx={{ minWidth: 1600 }}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows?.length}
            />
            <TableBody>
              {visibleRows?.map((row, index) => {
                const isItemSelected = selected.includes(row.id);
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                    className="btn"
                  >
                    <TableCell className="no-wrap" align="left">{row.name}</TableCell>
                    <TableCell className="no-wrap" align="left">{row.email ? row.email : "N/A"}</TableCell>
                    <TableCell className="no-wrap" align="left">{row.phone ? row.phone : "N/A"}</TableCell>
                    <TableCell className="no-wrap" align="left">{row.source}</TableCell>
                    <TableCell className="no-wrap" align="left">
                      <ReadMoreArea
                      className="custom-read-more"
                        lettersLimit={90} // limit of letters (100 letters)
                      >
                        {row.commentText}
                      </ReadMoreArea>
                    </TableCell>
                    <TableCell className="no-wrap" align="left">{row.videoId}</TableCell>
                    <TableCell className="no-wrap" align="left">{row.commentType}</TableCell>
                    <TableCell className="no-wrap" align="left">{row.createAt}</TableCell>
                  </TableRow>
                );
              })}

            </TableBody>
          </Table>
          {loading && <Loader className='table-loader' />}
          {!leadData?.length && <NoData></NoData>}
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          count={leadData?.count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

    </>
  )
}

export default ManageLeadPreview